import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { FormFilePreview } from './file-preview/file-preview';
import { QuizQuestionWut } from '../../ui/quiz/quiz-question/quiz-question-wut';
import { useFieldAttributes } from '../../services/field-attributes';
import { useError } from '../../field-error';
import { FileInputWUT } from '../../inputs/file-input/file-input-wut';
import { FileUploadDetails, useFileUpload } from '../../ui/autocomplete/wut/FileUpload';
import { FieldErrorWUT } from '../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../ui/field-description/field-description-wut';
import { useFileUploadController } from '../../ui/file-upload/use-file-upload-controller';
const FileUploadComponent = _ref => {
  let {
    id,
    target,
    label,
    description,
    value,
    onChange,
    onFocus,
    onBlur,
    error,
    customErrors,
    disabled = false,
    buttonText,
    uploadFileFormats,
    valueSliderLimit,
    required,
    hideLabel,
    explanationText,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    questionImage,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement,
    questionImageAltText
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, FIELD_TYPES.QUIZ_FILE_UPLOAD);
  const {
    files,
    _error,
    hover,
    getExplanationText,
    handleChange,
    handleDelete,
    accept,
    handleBlur
  } = useFileUploadController({
    valueSliderLimit,
    value,
    explanationText,
    target,
    onChange,
    uploadFileFormats,
    onBlur
  });
  const {
    fileInputRef,
    fileUploadButtonRef,
    textBelowButtonRef,
    fileErrorMessage
  } = useFileUpload({
    files
  });
  const _errorMessage = fileErrorMessage || _error || errorMessage;
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      id: id,
      htmlFor: inputId,
      labelId: labelId,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement,
      imageAltText: questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(FileInputWUT, {
      onFocus: onFocus,
      onBlur: handleBlur,
      disabled: disabled,
      buttonText: buttonText,
      valueSliderLimit: valueSliderLimit,
      required: required,
      inputId: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      files: files,
      hover: hover,
      handleChange: handleChange,
      accept: accept,
      fileInputRef: fileInputRef,
      fileUploadButtonRef: fileUploadButtonRef,
      textBelowButtonRef: textBelowButtonRef,
      hasError: hasError
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileUploadDetails, {
      fileInputRef: fileInputRef,
      fileUploadButtonRef: fileUploadButtonRef,
      textBelowButtonRef: textBelowButtonRef,
      files: files,
      onDeleteClick: handleDelete,
      hasError: Boolean(_errorMessage),
      explanationText: getExplanationText()
    }), /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: Boolean(_errorMessage),
      errorMessage: _errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
const QuizFileUpload = props => {
  const {
    externalData,
    label,
    value,
    FieldLayout,
    required = true
  } = props;
  if (externalData != null && externalData.ownerPreview) {
    return /*#__PURE__*/React.createElement(FieldLayout, {
      fieldId: props.id
    }, /*#__PURE__*/React.createElement(FormFilePreview, {
      label: /*#__PURE__*/React.createElement(QuizQuestionWut, {
        id: props.id,
        error: props.error,
        description: props.description,
        required: required,
        label: label,
        hideLabel: props.hideLabel,
        requiredIndicatorType: props.requiredIndicatorType,
        requiredIndicatorPlacement: props.requiredIndicatorPlacement,
        image: props.questionImage,
        imageResize: props.questionImageResize,
        imageAlignment: props.questionImageAlignment,
        imagePlacement: props.questionImagePlacement,
        imageAltText: props.questionImageAltText
      }),
      value: value
    }));
  }
  return /*#__PURE__*/React.createElement(FileUploadComponent, _extends({}, props, {
    required: required
  }));
};
export default QuizFileUpload;
//# sourceMappingURL=quiz-file-upload.js.map